/* tslint:disable */
/* eslint-disable */
/**
 * Client dashboard
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProjectIndicatorResponse
 */
export interface ProjectIndicatorResponse {
    /**
     * 
     * @type {number}
     * @memberof ProjectIndicatorResponse
     */
    projectCounter: number;
    /**
     * 
     * @type {number}
     * @memberof ProjectIndicatorResponse
     */
    totalGsv: number;
}

/**
 * Check if a given object implements the ProjectIndicatorResponse interface.
 */
export function instanceOfProjectIndicatorResponse(value: object): value is ProjectIndicatorResponse {
    if (!('projectCounter' in value) || value['projectCounter'] === undefined) return false;
    if (!('totalGsv' in value) || value['totalGsv'] === undefined) return false;
    return true;
}

export function ProjectIndicatorResponseFromJSON(json: any): ProjectIndicatorResponse {
    return ProjectIndicatorResponseFromJSONTyped(json, false);
}

export function ProjectIndicatorResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectIndicatorResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'projectCounter': json['projectCounter'],
        'totalGsv': json['totalGsv'],
    };
}

export function ProjectIndicatorResponseToJSON(value?: ProjectIndicatorResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'projectCounter': value['projectCounter'],
        'totalGsv': value['totalGsv'],
    };
}

